import axios from '../../axiosConfig';

export const markOrganizationAsTrial = async (organizationId, payload) => {
  const response = await axios.patch(`/organizations/${organizationId}/mark_trial`, {
    organization: {
      days: payload?.days,
    },
  });
  return response?.data;
};

export const forceExpireOrganizationTrial = async (organizationId) => {
  const response = await axios.patch(`/organizations/${organizationId}/force_expire_trial`);
  return response?.data;
};

export const activateOrganizationTrial = async (organizationId) => {
  const response = await axios.patch(`/organizations/${organizationId}/activate_trial`);
  return response?.data;
};

export const extendOrganizationTrial = async (organizationId, payload) => {
  const response = await axios.patch(`/organizations/${organizationId}/extend_trial`, {
    organization: {
      days: payload?.days,
    },
  });
  return response?.data;
};
